import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';

import { AddVehicleInitiateVehicleModel } from '@amfam/policy/add-vehicle/data-access';
import { DriverAssignment, VehiclesInPolicy } from '@amfam/policy/models';
import { ACTIONS, UpdateDriverAssignmentsInput } from '@amfam/policy/vehicle-coverages/data-access';

@Component({
  selector: 'ds-vehicle-assignment',
  templateUrl: './vehicle-assignment.component.html',
  styleUrls: ['./vehicle-assignment.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class VehicleAssignmentComponent implements OnInit {
  @Input() driver: string;
  @Input() newDriver: { fixedId: string; displayName: string };
  @Input() newVehicles: VehiclesInPolicy[];
  @Input() filteredVehicles: VehiclesInPolicy[];
  @Input() selectedId: string;
  @Input() driverAssignments: DriverAssignment[];
  @Input() vehicles: AddVehicleInitiateVehicleModel[];
  @Input() form: UntypedFormGroup;
  @Input() isPartner: boolean;

  @Output() selectionChange = new EventEmitter();
  @Output() updateDriverAssignments = new EventEmitter<UpdateDriverAssignmentsInput>();

  public selectionCtrl: AbstractControl;

  ngOnInit(): void {
    this.selectionCtrl =
      this.form.controls[this.isPartner ? this.newDriver.fixedId.toString() : this.driver];
  }

  combinedVehicles() {
    if (this.driverAssignments.length === 0) {
      return this.filteredVehicles;
    }

    return [
      ...this.newVehicles.filter(
        v =>
          this.driverAssignments.filter(
            a => a.driverId.toString() === this.newDriver.fixedId.toString()
          )[0]?.vin === v.vin
      ),
      ...this.filteredVehicles
    ];
  }

  public emitUpdateDriverAssignments(payload: {
    vehicle: string;
    driver: { fixedId: number; displayName: string };
    selectedId: string;
    driverAssignments: DriverAssignment[];
  }) {
    this.updateDriverAssignments.emit({
      ...payload,
      vehicle: this.newVehicles.filter(v => v.description === payload.vehicle)[0],
      action: ACTIONS.ASSIGN_VEHICLE
    });
  }

  public vehicleAssignmentChange() {
    this.selectionChange.emit({
      driverName: this.driver,
      vehicle: this.vehicles.find(vehicle => vehicle.vin === this.selectionCtrl.value),
      vehicleAssignment: true
    });
  }
}
